import type {ReactElement} from 'react';
import React from 'react';
import {PosterEditingBaseColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-base-color-panel';
import type {ColorStorage} from '@Components/color-picker-v2';
import type {RGBA} from '@Utils/color.util';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromTableItem} from '@Hooks/poster-editor/useGetKeyFromTableItem';

export function LayoutHighlightedBackgroundColorPanel(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const itemHighlightedBackgroundColor = useGetKeyFromTableItem('highlightedBackgroundColor');

  if (!activeItem || (activeItem && !('highlightedBackgroundColor' in activeItem)) || !itemHighlightedBackgroundColor) {
    throw new Error('Item does not have highlightedBackgroundColor property');
  }

  const updateColor = (highlightedBackgroundColor: RGBA, undoable = true): void => {
    activeItem.updateHighlightedBackgroundColor(highlightedBackgroundColor, undoable);
  };

  const onChangeColor = (updatedColor: ColorStorage[]): void => {
    updateColor(updatedColor[0].color, false);
  };

  const onChangeEnded = (updatedColor: ColorStorage[]): void => {
    updateColor(updatedColor[0].color);
  };

  return (
    <PosterEditingBaseColorPanel
      id="schedule-highlighted-background-color-panel"
      isGradientEnabled={false}
      color={getColorObjectArrayFromFillColor([itemHighlightedBackgroundColor])}
      onChangeColor={onChangeColor}
      onChangeEnded={onChangeEnded}
    />
  );
}
